export default __webpack_public_path__ + "static/media/draingPad.aedcfbb4.png";